export default __webpack_public_path__ + "static/media/highlight_2.f05eb029.jpg";